import { PriceDTO, PriceRequest } from '@api/ringil-api.v2.tsx';
import { isNullOrUndefined } from '@utils/utils.tsx';

export const formatPrice = (price: number, currency: string, maximumFractionDigits: number = 2) => {
  return `${price?.toLocaleString('cs', { maximumFractionDigits }) || '-'} ${currency? currency : ''}`;
};

export const formatPriceRequest = (priceRequest: PriceRequest) => {
  if (isNullOrUndefined(priceRequest) || isNullOrUndefined(priceRequest.price) || isNullOrUndefined(priceRequest.currency)) return '-';

  return `${priceRequest.price.toLocaleString('cs', { minimumFractionDigits: 2 }) || '-'} ${priceRequest.currency}`;
};

export function sumPriceDTOs(prices: PriceDTO[]): PriceDTO | null {
  if (!prices || prices.length === 0) return null;

  const filtered = prices.filter((p): p is PriceDTO => !isNullOrUndefined(p));
  if (filtered.length === 0) return null;

  const first = filtered[0];
  const result: PriceDTO = { ...first };

  const safeNumber = (v?: number | null) => isNullOrUndefined(v) ? 0 : v;

  result.price = filtered.reduce((acc, p) => acc + safeNumber(p.price), 0);
  result.companyComputedPrice = filtered.reduce((acc, p) => acc + safeNumber(p.companyComputedPrice), 0);

  result.currency = first.currency;
  result.companyComputedCurrency = first.companyComputedCurrency;
  result.conversationRate = first.conversationRate;

  return result;
}